import { Injectable } from '@angular/core';

import { QueryEntity } from '@datorama/akita';

import { FloorPlanItemState } from './floor-plan-item.state';
import { FloorPlanItemStore } from './floor-plan-item.store';

@Injectable({ providedIn: 'root' })
export class FloorPlanItemQuery extends QueryEntity<FloorPlanItemState> {
  constructor(protected readonly store: FloorPlanItemStore) {
    super(store);
  }
}
